<video crossorigin="anonymous" class="video-js vjs-default-skin video-initial" [id]="id" #target controls playsinline>
    <!-- The ng-content is meant for projecting text tracks (Closed Captions) or other HTML elements native video tags support -->
    <ng-content></ng-content>
</video>
